import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import ApiConstants from 'src/app/shared/constants/api.constants';
import { catchError } from 'rxjs/operators';
import { DashboardResponse } from '../../shared/model/dashboard.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getDashboardData(): Observable<DashboardResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.DASHBOARD}`;
    return this.http
      .get<DashboardResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
